export default "__VITE_ASSET__m_p8Z5C0__"